import spreadsheetsApiClient from '../../lib/spreadsheetsApiClient';
import * as types from '../types';
const takeSolution = (exerciseId, xpCost, environment) => async dispatch => {
  dispatch({
    exerciseId,
    type: types.TAKE_SOLUTION_REQUESTED,
    xpCost
  });
  try {
    await spreadsheetsApiClient(environment).takeSolution(exerciseId);
    dispatch({
      exerciseId,
      type: types.TAKE_SOLUTION_COMPLETED
    });
  } catch (error) {
    dispatch({
      exerciseId,
      type: types.TAKE_SOLUTION_FAILED,
      xpRefund: xpCost
    });
  }
};
export default takeSolution;